/**
 * Created by noOne on 25/08/2017.
 */

"use strict";

import Entity3D from "./Entity3D";

export default class Ray extends Entity3D {
    constructor() {
        super();
        /**
         * @type {PIXI.Point}
         * @private
         */
        this._position = new PIXI.Point();

        /**
         * @type {PIXI.Point}
         * @private
         */
        this._dir = new PIXI.Point();
    }
}